import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { Checkbox } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function FacilitationGuidePage() {
  const [warmupComplete, setWarmupComplete] = useState(false);
  const [inventoryComplete, setInventoryComplete] = useState(false);
  const [filtersComplete, setFiltersComplete] = useState(false);
  const [criteriaComplete, setCriteriaComplete] = useState(false);
  const [playComplete, setPlayComplete] = useState(false);
  const [statementComplete, setStatementComplete] = useState(false);
  const [closeComplete, setCloseComplete] = useState(false);

  return (
    <TaskPage
      phase="decide"
      title="Facilitation Guide"
      pageNumber={7}
      instruction="Suggested timing: 60–90 min total. Use this guide to facilitate a team session."
      whyItMatters="Keep flow modular; alternate solo ↔ pair ↔ group; close strong to improve transfer to real work."
      coachRail={{
        timing: "60-90 minutes total",
        tips: "Opener: 'One thing I stopped doing that helped' (≤30s each). Closer: 'Cut I'm proudest of' + 'first next action.'",
        debrief: "What pattern did the inventory reveal? Which criterion did you use most? What did we not choose—and why?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Suggested Timing (60–90 min total)</h3>
          <div className="space-y-3">
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={warmupComplete}
                onChange={(e) => setWarmupComplete(e.target.checked)}
                label="Warm-up & norms — 5 min"
              />
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={inventoryComplete}
                onChange={(e) => setInventoryComplete(e.target.checked)}
                label="Inventory — 10 min"
              />
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={filtersComplete}
                onChange={(e) => setFiltersComplete(e.target.checked)}
                label="Fast Filters — 15 min"
              />
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={criteriaComplete}
                onChange={(e) => setCriteriaComplete(e.target.checked)}
                label="Criteria — 10 min"
              />
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={playComplete}
                onChange={(e) => setPlayComplete(e.target.checked)}
                label="Play It Out — 15 min"
              />
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={statementComplete}
                onChange={(e) => setStatementComplete(e.target.checked)}
                label="Priority Statement — 10–20 min"
              />
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={closeComplete}
                onChange={(e) => setCloseComplete(e.target.checked)}
                label="Close — 5 min"
              />
            </label>
          </div>
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Opener & Closer</h3>
          <div className="space-y-3 text-sm text-[var(--text-sec)]">
            <div>
              <p className="font-semibold">Opener:</p>
              <p>"One thing I stopped doing that helped" (≤30s each)</p>
            </div>
            <div>
              <p className="font-semibold">Closer:</p>
              <p>"Cut I'm proudest of" + "first next action."</p>
            </div>
          </div>
        </div>

        <div className="bg-[var(--green-dim)] border border-[var(--green)] p-6">
          <h3 className="text-lg font-semibold text-[var(--green)] dark:text-[var(--text-ter)] mb-4">Safety Norms</h3>
          <div className="space-y-2 text-sm text-[var(--green)] dark:text-[var(--text-ter)]">
            <p>• Confidentiality</p>
            <p>• Curiosity</p>
            <p>• Timeboxing</p>
            <p>• "Disagree & commit"</p>
          </div>
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Debrief Prompts</h3>
          <div className="space-y-2 text-sm text-[var(--text-sec)]">
            <p>• What pattern did the inventory reveal?</p>
            <p>• Which criterion did you use most?</p>
            <p>• What did we not choose—and why?</p>
          </div>
        </div>

        <Callout type="tip" phase="decide">
          <p className="text-sm">Alternate between solo work, pairs, and group discussion. Keep the flow modular and timeboxed.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






